var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnalitycs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc517;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#f57e02;}.cls-3{fill:url(#Degradado_sin_nombre_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 2036.7,
    y1: -305.14,
    x2: 2041.14,
    y2: -305.14,
    gradientTransform: "matrix(2.72, 0, 0, -2.72, -5510.29, -799.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e96f0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37901"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.31,42.7H10.21A2.91,2.91,0,0,1,7.3,39.79V33.51a2.91,2.91,0,0,1,2.91-2.92h8.28V21.4a2.91,2.91,0,0,1,2.91-2.91h9.19V42.63H23.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.79,42.7h-9.2V10.21A2.91,2.91,0,0,1,33.51,7.3h6.28a2.91,2.91,0,0,1,2.91,2.91V39.79A3,3,0,0,1,39.79,42.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.63,30.59v9.2a2.91,2.91,0,0,1-2.92,2.91H30.52V18.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalitycs);
export default __webpack_public_path__ + "static/media/Icon-Analitycs.aa49a93be68eb278819e4b87c7846342.svg";
export { ForwardRef as ReactComponent };